export default "__VITE_ASSET__26330c81__"